import 'shims';

import Loader from 'Loader';

import ApiMetadata from './Metadata';
import RequestAuth from './RequestAuth';
import RequestEnvelope from './RequestEnvelope';
import RequestSerializer from 'ApiTest/Serializer';
import PageController from 'App/PageController';
import docs from './docs';
import RequestGenerator from './RequestGenerator';

function fetchMetadata(siteConfig) {
  var req = new RequestEnvelope('Doc', new RequestAuth({ type : 'none' }));

  req.addSubRequest('getMetadata', {});

  const url = `${siteConfig.API_URL}Doc`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: RequestSerializer.serialize('json', req),
  };

  return fetch(url, options)
    .then(resp => resp.json())
    .then(data => {
      if (!data.responseList || !data.responseList.requestItem || !data.responseList.requestItem[0] || !data.responseList.requestItem[0].result || data.responseList.requestItem[0].result.error) {
        throw new Error('Invalid loadMetadata() response');
      }

      return data.responseList.requestItem[0].result.metadata;
    });
}

var pageController;

Loader.load()
  .then(siteConfig => {
    const { apiConfig } = siteConfig;
    RequestAuth.setMetadata(apiConfig.auth);

    pageController = new PageController();

    return fetchMetadata(siteConfig)
      .then(res => {
        ApiMetadata.setMetadata(res);

        docs.init(pageController, {
          pages: siteConfig.PAGES,
          API_URL: siteConfig.API_URL
        });

        const requestGenerator = new RequestGenerator(siteConfig, apiConfig);
        pageController.addPageContainerToDom(requestGenerator.root);
        requestGenerator.finishInit();

        var testPage = {
          title    : 'Test Page',
          path     : 'TestPage',
          container: requestGenerator.root,
          handler  : function() {
            requestGenerator.activate();
          }
        };

        pageController.addPage(testPage);
      });
  })
  .then(() => pageController.show())
  .then(() => Loader.loadComplete())
  .catch(err => Loader.loadError(err));
